const map = <T, U>(set: Set<T>, fn: (value: T) => U) =>
  new Set([...set].map(fn));

const union = <T>(a: Set<T>, b: Set<T>): Set<T> => new Set([...a, ...b]);

export const setLib = {
  map,
  union,
};
